var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-jumbotron',{attrs:{"header":this.headerText,"lead":this.message}},[_c('b-button',{staticClass:"with-icon",attrs:{"pill":"","variant":"congress"},on:{"click":_vm.login}},[_c('i',{staticClass:"las la-5x la-t-plus-3 la-user-circle pr-1"}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }